<template>
    <div>
        <el-form style="float:left;width: 100%" :model="queryParams" :rules="queryParamsRules" ref="paramsForm">
            <el-form-item style="display:inline-block;margin-right: 10px" prop="baseType">
                <el-select v-model="queryParams.baseType">
                    <el-option value="USDT" label="USDT合约"></el-option>
                    <el-option value="COIN" label="币本位合约"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px" prop="userId">
                <el-input v-model="queryParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-input v-model="queryParams.symbol" placeholder="交易对" style="width: 200px"></el-input>
            </el-form-item>
            <el-button type="primary" @click="getOpenOrders">搜 索</el-button>
        </el-form>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="orderId" label="订单ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pair" label="标的交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="订单类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="avgPrice" label="平均成交价" show-overflow-tooltip></el-table-column>
            <el-table-column prop="clientOrderId" label="用户自定义的订单号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cumBase" label="成交金额(标的数量)" show-overflow-tooltip></el-table-column>
            <el-table-column prop="executedQty" label="成交量(张数)" show-overflow-tooltip></el-table-column>
            <el-table-column prop="origQty" label="原始委托数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="origType" label="触发前订单类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="price" label="委托价格" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reduceOnly" label="是否仅减仓" show-overflow-tooltip></el-table-column>
            <el-table-column prop="side" label="买卖方向" show-overflow-tooltip></el-table-column>
            <el-table-column prop="positionSide" label="持仓方向" show-overflow-tooltip></el-table-column>
            <el-table-column prop="stopPrice" label="触发价" show-overflow-tooltip></el-table-column>
            <el-table-column prop="closePosition" label="是否条件全平仓" show-overflow-tooltip></el-table-column>
            <el-table-column prop="timeInForce" label="有效方法" show-overflow-tooltip></el-table-column>
            <el-table-column prop="activatePrice" label="跟踪止损激活价格" show-overflow-tooltip></el-table-column>
            <el-table-column prop="priceRate" label="跟踪止损回调比例" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workingType" label="条件价格触发类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="priceProtect" label="是否开启条件单触发保护" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="订单状态" show-overflow-tooltip></el-table-column>
            <el-table-column label="时间">
                <template slot-scope="scope">
                    <span>{{scope.row.time | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="更新时间">
                <template slot-scope="scope">
                    <span>{{scope.row.updateTime | moment}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import "../../store";
    import api from "../../api";

    export default {
        name: "AllBills",
        data() {
            return {
                dataList: [],
                queryParams: {
                    baseType: "USDT",
                    userId: "",
                    symbol: ""
                },
                queryParamsRules: {
                    "baseType": [{required: true, message: "类型不能为空"}],
                    "userId": [{required: true, message: "用户ID不能为空"}]
                },
            };
        },
        methods: {
            getOpenOrders() {
                this.$refs["paramsForm"].validate(valid => {
                    if (valid) {
                        api.getOpenOrders(this.queryParams).then(({data}) => {
                            this.dataList = data;
                        });
                    }
                });
            },
        },
        created() {
        },
    };
</script>

<style lang="less" scoped>

</style>